import { render, staticRenderFns } from "./VoyageInfoSummary.vue?vue&type=template&id=5c6a2288&scoped=true&"
import script from "./VoyageInfoSummary.vue?vue&type=script&lang=js&"
export * from "./VoyageInfoSummary.vue?vue&type=script&lang=js&"
import style0 from "./VoyageInfoSummary.vue?vue&type=style&index=0&id=5c6a2288&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6a2288",
  null
  
)

export default component.exports